import React, { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../assets/logo.png";
import loginIcon from "../assets/loginIcon.png";
import logoutIcon from "../assets/logout.png"; // Import logout icon
import { LanguageContext } from "../LanguageContext"; // Import the context

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // State for mobile menu
  const { language, toggleLanguage } = useContext(LanguageContext); // Use the context

  // Check if a token exists in session storage
  const token = sessionStorage.getItem("token");

  // Function to determine if a link is active
  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  // Handle logout
  const handleLogout = () => {
    sessionStorage.removeItem("profile"); // Remove the token from session storage
    sessionStorage.removeItem("token"); // Remove the token from session storage
    navigate("/login"); // Redirect to the login page
  };

  const userData = JSON.parse(sessionStorage.getItem("profile"));

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Text content for English and Arabic
  const text = {
    en: {
      home: "Home",
      about: "About Us",
      subscriptions: "Subscriptions",
      tutorial: "Tutorial",
      safety: "Safety tips",
      community: "Community guidelines",
    },
    ar: {
      home: "الرئيسية",
      about: "اقرأ عنا",
      subscriptions: "الاشتراكات",
      tutorial: "البرنامج التعليمي",
      safety: "نصائح السلامة",
      community: "ارشادات المجتمع",
    },
  };

  // Fallback to English if language is invalid
  const currentText = text[language] || text.en;

  return (
    <nav className={`navbar ${language === "ar" ? "rtl" : ""}`}>
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Logo furever" className="logo" />
        </Link>
      </div>

      {/* Hamburger Button for Mobile */}
      <div
        className={`navbar-hamburger ${isMobileMenuOpen ? "open" : ""}`}
        onClick={toggleMobileMenu}
      >
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
      </div>

      {/* Navigation Links and Auth Section */}
      <div
        className={`navbar-links ${isMobileMenuOpen ? "active" : ""}  ${
          language === "ar" ? "navbar-rtl" : ""
        }`}
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <Link to="/" className={isActive("/")} onClick={toggleMobileMenu}>
          {currentText.home}
        </Link>
        <Link
          to="/about"
          className={isActive("/about")}
          onClick={toggleMobileMenu}
        >
          {currentText.about}
        </Link>
        <Link
          to="/community"
          className={isActive("/community")}
          onClick={toggleMobileMenu}
        >
          {currentText.community}
        </Link>
        <Link
          to="/safety"
          className={isActive("/safety")}
          onClick={toggleMobileMenu}
        >
          {currentText.safety}
        </Link>
        {/* Language Toggle Button inside Mobile Menu */}
        <button onClick={toggleLanguage} className="language-toggle-mobile">
          {language === "en" ? "AR" : "EN"}
        </button>
      </div>

      {/* Auth Section */}
      <div className="navbar-auth">
        {token ? (
          <>
            <Link to="/profile" onClick={toggleMobileMenu}>
              <img
                src={userData.profilePicture}
                alt="Profile"
                className="profile-navbar"
              />
            </Link>
            <img
              src={logoutIcon}
              alt="Logout"
              className="logout-icon"
              onClick={() => {
                handleLogout();
                toggleMobileMenu();
              }}
            />
          </>
        ) : (
          ""
        )}

        {/* Language Toggle Button */}
        <button onClick={toggleLanguage} className="language-toggle">
          {language === "en" ? "AR" : "EN"}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
